import { useEffect, useState } from "react";
import { NavatarV2 } from "@amzn/aws-marketing-identity-kit-navatar";
import { useAuthV2 } from "@amzn/aws-marketing-identity-kit-essentials";
import "@amzn/aws-marketing-identity-kit-navatar/dist/styles/v2/styles.min.css";
import { languageToLocaleMap } from "@/lib/constants/i18n";
import { initializeI18n } from "@amzn/aws-marketing-identity-kit-localizations";
import { ProfileFormTranslations } from "@amzn/aws-marketing-identity-kit-localizations/locales/profile-form";
import Cookies from "js-cookie";
import { VALID_SESSION_COOKIE_KEY } from "@/lib/constants/awsm";

const NavatarComponent = ({ language }: { language: string }) => {
  const awsmValidSessionCookie = Cookies.get(VALID_SESSION_COOKIE_KEY);
  const { setSession, loadProfile, profile, logout, login } = useAuthV2();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const initializeSession = async () => {
      if (!awsmValidSessionCookie) return;
      try {
        await setSession();
        await loadProfile();
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
      }
    };
    initializeSession();
  }, [awsmValidSessionCookie]);
  initializeI18n(ProfileFormTranslations, languageToLocaleMap[language]);

  return (
    <NavatarV2
      profile={profile}
      avatarUrl={profile?.picture || ""}
      locale={languageToLocaleMap[language]}
      logout={logout}
      login={login}
      profilePageUrl={`/${language}/profile`}
      isAuthenticated={isAuthenticated}
      displayGlobalDialog={true}
    ></NavatarV2>
  );
};

export default NavatarComponent;
